var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"home",staticClass:"home"},[(_vm.dslModel.imagesObj.home)?_c('img',{staticStyle:{"width":"65%","height":"75%"},attrs:{"src":_vm.dslModel.imagesObj.home,"alt":""}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }